import { useQuery } from '@tanstack/react-query';

import { getDiscoveryService } from '../services/discoveryService';

export function useManifest(clientName: string) {
  const discoveryService = getDiscoveryService()!;

  const MILLIS_PER_SECOND = 1000;
  return useQuery({
    staleTime: 300 * MILLIS_PER_SECOND,
    queryKey: ['manifest.json', clientName],
    queryFn: async () => {
      const manifestData = await discoveryService.getManifestData();
      return manifestData;
    },
  });
}
